import { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-6 left-6 z-50 w-12 h-12 flex items-center justify-center bg-[#FF6B35] text-white rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer"
          aria-label="Volver arriba"
        >
          <i className="ri-arrow-up-line text-2xl"></i>
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;